import React from 'react';

export default function ScoreBadge({ score }) {
  if (score === undefined || score === null) {
    return <span className="badge badge-sm bg-gray-400 text-white">N/A</span>;
  }

  let colorClass = '';
  let label = '';

  if (score >= 80) {
    colorClass = 'bg-green-500 text-white';
    label = 'Excelente';
  } else if (score >= 65) {
    colorClass = 'bg-blue-500 text-white';
    label = 'Bom';
  } else if (score >= 50) {
    colorClass = 'bg-yellow-500 text-white';
    label = 'Médio';
  } else if (score >= 30) {
    colorClass = 'bg-orange-500 text-white';
    label = 'Baixo';
  } else {
    colorClass = 'bg-red-500 text-white';
    label = 'Muito Baixo';
  }

  return (
    <div className="flex items-center space-x-1">
      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${colorClass}`}>
        ⭐ {score}
      </span>
      <span className="text-xs text-gray-500">{label}</span>
    </div>
  );
}
